import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { TipoOrdenamiento } from '../../containers/bandeja-principal/administrador/notificaciones-correos-masivos/enviados/notificaciones-correos-masivos-enviados.component';
export interface IHeaderOrderModel{
  label         : string;
  column_name   : string;
  current_order : TipoOrdenamiento;
  is_sortable   : boolean;
}
@Component({
  selector: 'app-tablas-order',
  templateUrl: './tablas-order.component.html',
  styleUrls: ['./tablas-order.component.scss']
})
export class TablasOrderComponent implements OnInit {
  @Input()
	headers: Array<IHeaderOrderModel>;

	@Input()
	body: Array<any>;

	@Input()
	sizeData: number;

	@Input()
	page: number;

	@Input()
	paginar = true;

	@Input()
	filtrar = false;

	@Output()
	valueEmitter = new EventEmitter();

	@Output()
	paginado = new EventEmitter();

  @Output()
	orderBy = new EventEmitter<string>();


	@Input()
	pageSize = 12;

	selectData: any;

	constructor() {
	}

	ngOnInit() {
		
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.body) {
			this.sizeData = this.body.length;
		}
	}

	selectRow(value: any) {
		this.selectData = value;
		this.valueEmitter.emit(value);
	}

	onPaginado(value: any) {
		this.paginado.emit(value);
	}

	getEntries(value: object) {
		return Object.keys(value).map((key) => value[key]);
	}
	modifyOrder(index: number): void{
		const item = this.headers[index];
		if(item != null){
			item.current_order++;
			if(item.current_order > 3){
				item.current_order = 1;
			}
			this.headers[index]= item;
			this.orderBy.emit(this.orderModelToString());
		}
	}
	orderModelToString(): string{
		let arrayAux: string[]=[];
		this.headers.forEach( header => {
			if(header.current_order == 1){
				arrayAux.push(header.column_name + ' ASC ');
			}
			if(header.current_order == 2){
				arrayAux.push(header.column_name + ' DESC ');
			}
		});
		return arrayAux.join(',')== ''?null:arrayAux.join(',');
	}
}
